import api from "./api.js"
import $store from '../store/index.js'
import axios from 'axios'
import App from '@/assets/app.js';
import $router from '../router'

export default function(){
		//拦截器
		axios.interceptors.request.use(
			config => {
				// console.log(config)
				config.headers.token = $store.state.token
				return config
			}, err => {
				console.log(err)
			})
		//响应拦截器
		axios.interceptors.response.use(
			response => {
				// console.log(response)
				if (response.data.code) {//失效
					if (response.data.code === 3000) {
						App.oTool.warningT(response.data.qmismsg);
						// location.href = '/'
						// location.href = '/qmisAdmin'
						// 部署修改
						// location.href='https://hk.qmisit.com/qmisAdmin'
						location.href='http://202.130.113.149/khadmin'
						// location.href='http://47.243.50.48/qmisAdmin'
						$router.push({path: '/'});
					}
				}
				return response
			}, error => {
				//接口错误状态处理，无响应处理
				
				// App.oTool.warningT(error.data.qmismsg);
				return Promise.reject(error) //接口返回的错误信息
			})
	}
